import React, {
	useContext,
	useState,
	useEffect
} from 'react';
import PropTypes from 'prop-types';
import MomentCore from 'moment';

import {
	makeStyles,
	useTheme,
	Card,
	CardActionArea,
	CardContent,
	Typography,
	Grid,
	Divider
} from '@material-ui/core';

import Constants from "../utils/Constants";
import HTMLEntities from "../utils/HTMLEntities";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import PatternMomentum from "./PatternMomentum";
import ActivityTopics from "./ActivityTopics";
import PatternMetrics from "./PatternMetrics";
import HorizontalTimeline from "./HorizontalTimeline";

const styles = makeStyles(theme => ({
	card: {
		maxWidth: "100%",
		margin: "0 auto",
		border: "1px solid #D9DCDD",
		padding: 8,
		borderRadius: 16,
		minHeight: 470,
	},

	cardAction: {
		// maxWidth: theme.spacing(76.25)
		maxWidth: "100%",
		
	},

	cardContent: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
		paddingLeft: theme.spacing(1.5),
		paddingRight: theme.spacing(1.5),
		// border: `1px solid ${theme.palette.secondary.lightGrey}`,
		// borderRadius: 16,
	},

	subTitle: {
		fontSize: "1rem",
		lineHeight: "1.7rem",
		paddingTop: theme.spacing(2)
	},

	title: {
		fontSize: "1.33rem"
	},

	metricsCards: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5)
	},

	mostRecent: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5),
		minHeight: 230,
	},

	timeline: {
		paddingTop: theme.spacing(5),
		paddingBottom: theme.spacing(1.5)
	},

	hasChanges: {
		// borderTop: `5px solid ${theme.palette.secondary.mustard}`
	},

	libraryTopics: {
		fontSize: "16px"
	},

	divider: {
		margin: "10px -32px"
	}
}));

function PatternCard(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const [events, setEvents] = useState();
	const theme = useTheme();

	let classes = styles(),
		{item, clickHandler} = props,
		inActivePattern = item.status === Constants.PATTERN.STATUSES.INACTIVE;

	useEffect(() => {
		let evs = [];

		item.signals.map((signal, idx) => {
			let isDiscussion = signal.category === Constants.ACTIVITY.CATEGORIES.DISCUSSIONS.ID,
				isDetectionSignal = Constants.PATTERN.isDetectionDate(item, signal.publishedAt);

			return evs.push({
				style: {
					zIndex: isDetectionSignal ? 2 : (isDiscussion ? null : 1),
					backgroundColor: isDetectionSignal ? theme.palette.secondary.orange : 
						(isDiscussion ? theme.palette.primary.mediumGrey : theme.palette.error.main),
				},
				date: signal.publishedAt,
				label: idx === 0 || isDetectionSignal || (inActivePattern && idx === item.signals.length-1)  ?
					(new MomentCore(signal.publishedAt)).format("MMM DD") : null
			});
		});
		setEvents(evs);
	}, [item, theme, inActivePattern]);

	return (
		<Card className={`${classes.card} ${item.hasChanges ? classes.hasChanges : ""}`}>
			<CardActionArea
				className={classes.cardAction}
				onClick={() => clickHandler(item)}>
				<CardContent className={classes.cardContent}>
					<Grid
						container
						spacing={2}
						direction="row"
						justifyContent="space-between"
						wrap="nowrap">
						<Grid item>
							<ActivityTopics
								topics={item.libraryTopics}
								className={classes.libraryTopics} />
						</Grid>
						<Grid item>
							<PatternMomentum
								status={item.status}
								momentum={item.momentumChange} />
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						direction="row"
						justifyContent="space-between"
						wrap="nowrap">
						<Grid item>
							{AuthorizedUser.hasMultipleLocations(authenticatedUser) ? (
								<Typography variant="h2" noWrap className={classes.subTitle}>
									<b>{item.locationName}</b>
								</Typography>
							) : null}
							<Typography variant="h2" noWrap className={classes.title}>
								<b>{item.name}</b>{item.email && <span>&nbsp;&lt;{item.email}&gt;</span>}
							</Typography>
						</Grid>
					</Grid>
					<Divider className={classes.divider}/>
					<div className={classes.metricsCards}>
						<PatternMetrics data={item.counts} />
					</div>
					<Grid container direction='column' justifyContent='space-between'>
					<Grid item>
					<div className={classes.mostRecent}>
						<Typography>
							<b>{item.mostRecentActivity.title}</b>
						</Typography>
						<Typography>
							{HTMLEntities.decode(item.mostRecentActivity.content)}
						</Typography>
					</div>
					</Grid>
					<Grid item>
					<div className={classes.timeline}>
						<HorizontalTimeline
							events={events}
							isOpenEnded={!inActivePattern}
							labelColor={theme.palette.primary.mediumGrey}
							tooltip={
								<div>
									<div>Patterns are made of Signals, Alerts & Discussions.</div>
									<div><br/>- Red dots are Alerts</div>
									<div>- Grey dots are Discussions</div>
									<div>- Orange dots are signals that triggered the detection of a pattern</div>
								</div>
							} />
					</div>
					</Grid>
					</Grid>
				</CardContent>
			</CardActionArea>
		</Card>
	);
}

PatternCard.propTypes = {
	item: PropTypes.object.isRequired,
	clickHandler: PropTypes.func.isRequired
};

export default PatternCard;